// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"21":"authorinformation","587":"editiondetails","739":"privacypolicy","882":"contactusers","901":"archives","967":"viewusers"}[chunkId] + "." + {"21":"ff15eba8","587":"b66168f4","739":"db9e5517","882":"bcfc91dc","901":"2fcab7fb","967":"657a960d"}[chunkId] + ".css";
};